module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.$store.state.loading),
      expression: "$store.state.loading"
    }],
    attrs: {
      "element-loading-text": "Loading...",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.8)"
    }
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-scroller bg-primary box-shadow"
  }, [_c('nav', {
    staticClass: "nav nav-underline"
  }, [_c('router-link', {
    staticClass: "nav-link text-white",
    attrs: {
      "active-class": "active",
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_vm._v("\n        Dashboard\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link text-white",
    attrs: {
      "active-class": "active",
      "to": {
        name: 'Forms'
      }
    }
  }, [_vm._v("\n        Forms\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link text-white",
    attrs: {
      "active-class": "active",
      "to": {
        name: 'Settings'
      }
    }
  }, [_vm._v("\n        Settings\n      ")])], 1)]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f52bf9d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue
// module id = 435
// module chunks = 4